import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Modal} from '@softline/ui-core';
import { Legierung } from '../../types/lagerartikel';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'soft-legierung-auswahl-dialog',
    templateUrl: './legierung-auswahl-dialog.component.html',
    styleUrls: ['./legierung-auswahl-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class LegierungAuswahlDialogComponent implements OnInit, Modal<Legierung | null> {

  legierungen: Legierung[] = [];
  close!: (result: (Legierung | null)) => void;

  constructor() { }

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: (Legierung | null)) => void) {
    this.close = handler;
  }
}
